import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { lastValueFrom, map } from 'rxjs';
import {
  MovementControllerService,
  MovementExecutionEmail,
  PageableRequest
} from 'src/app/admin-api';
import { PageContent, TableColumn } from 'src/app/components/table';

@Component({
  selector: 'app-movements-history',
  templateUrl: './movements-history.component.html',
  styleUrl: './movements-history.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MovementsHistoryComponent implements OnInit {
  readonly movementService = inject(MovementControllerService);
  private title = inject(Title);
  private router = inject(Router);

  cols: TableColumn[] = [
    new TableColumn.Builder()
      .setHeader('Data')
      .setField('createdAt')
      .setType('date')
      .setCondition('between')
      .build(),
    new TableColumn.Builder()
      .setHeader('Tipo')
      .setField('movementLabel')
      .setType('text')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('E-mail')
      .setField('email')
      .setType('text')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Nº do pedido')
      .setField('shippingOrderId')
      .setRouterLink('/products/shipping-orders/')
      .setRouterLinkFieldName('shippingOrderId')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('resultStatus')
      .setType('text')
      .setCondition('equals')
      .build(),
    new TableColumn.Builder()
      .setHeader('Mensagem')
      .setField('resultMessage')
      .setType('text')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Gerado por')
      .setField('createdBy')
      .setType('text')
      .setCondition('contains')
      .build()
  ];

  dropdownFilters = {
    resultStatus: [
      { label: 'Todos', value: '' },
      { label: 'Sucesso', value: 'SUCCESS' },
      { label: 'Erro', value: 'ERROR' },
      { label: 'Não encontrado', value: 'NOT_FOUND' }
    ]
  };

  ngOnInit(): void {
    this.title.setTitle('Marketing - Histórico de Movimentações');
  }

  goBack(): void {
    this.router.navigate(['/marketing/movements']);
  }

  async findPage(
    request: PageableRequest,
    service: unknown
  ): Promise<PageContent<MovementExecutionEmail>> {
    return lastValueFrom(
      (service as MovementControllerService)
        .history(request)
        .pipe(map((data) => data.result as PageContent<MovementExecutionEmail>))
    );
  }
}
